import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';

const ProgressBar = ({ percentage, className = '' }) => {
  const { semantic } = useColors();

  return (
    <div className={`w-full ${semantic.sectionBg} rounded-full h-2.5 ${className}`} role="progressbar" aria-valuenow={percentage} aria-valuemin="0" aria-valuemax="100">
      <div 
        className={`${semantic.highlightPrimaryBg} h-2.5 rounded-full transition-all duration-300`}
        style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
      ></div>
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  className: PropTypes.string
};

export default ProgressBar;

